<div class="w-100 profile-navbar">
  <p class="d-block d-xl-none f-color-dark fw-SemiBold f-size-18 mb-4">
    {{ userFullName }}
  </p>
  <a (click)="closeModal()" [routerLink]="'/auction/create'">
    <button
      *ngIf="getUserCanManageAuction"
      class="d-block d-xl-none btn btn-link profile-navbar__btn profile-navbar__btn__add-auction"
    >
      დაამატე აუქციონი
    </button>
  </a>
  <p
    *ngIf="userBalance"
    class="f-color-dark profile-navbar__item text-decoration-none d-xl-none"
  >
    ბალანსი: <span class="fw-medium">{{ userBalance }}₾</span>
  </p>
  <a
    *ngIf="isUserAdmin"
    class="f-color-dark profile-navbar__item cursor-pointer d-xl-none"
    [routerLink]="'/admin'"
    ><p class="f-color-dark profile-navbar__item">ადმინი</p></a
  >
  <p
    (click)="openModal('FillBalanceComponent')"
    class="f-color-dark profile-navbar__item cursor-pointer d-xl-none"
  >
    თანხის შემოტანა
  </p>
  <p
    (click)="openModal('WithdrawBalanceComponent')"
    class="f-color-dark profile-navbar__item cursor-pointer d-xl-none"
  >
    თანხის გატანა
  </p>
  <a
    *ngFor="let item of getProfileRoutes"
    (click)="closeModal()"
    [routerLink]="item.route"
    ><p class="f-color-dark profile-navbar__item">{{ item.title }}</p></a
  >
  <!-- <a routerLink="/profile/personal-information"><p class="f-color-dark profile-navbar__item">პირადი ინფორმაცია</p></a>
  <a routerLink="/profile/bank-details"><p class="f-color-dark profile-navbar__item">საბანკო რეკვიზიტები</p></a>
  <a routerLink="/profile/change-password"><p class="f-color-dark profile-navbar__item">პაროლის შეცვლა</p></a>
  <a routerLink="/profile/favorites"><p class="f-color-dark profile-navbar__item">ფავორიტები</p></a>
  <a routerLink="/profile/notifications"><p class="f-color-dark profile-navbar__item">შეტყობინებები</p></a>
  <a routerLink="/profile/transaction-history"><p class="f-color-dark profile-navbar__item">ტრანზაქციების ისტორია</p></a> -->
  <button
    class="d-block d-xl-none btn btn-link profile-navbar__btn profile-navbar__btn__logout"
    (click)="logout()"
  >
    ანგარიშიდან გასვლა
  </button>
</div>
